import React from 'react';

function Header() {
  return <div></div>;
}

export default Header;
